export default
{
  OwnersPaymentLogs: [],
  OwnersPaymentLog: {},
}
